import { useAuthenticationProvider } from 'infrastructure/security/authentication/AuthenticationProvider';

export const useIsCurrentEmployee = () => {
  const { getUserAlias } = useAuthenticationProvider();
  const currentUserAlias = getUserAlias();

  return (alias?: Nullable<string>) => Boolean(alias) && alias === currentUserAlias;
};
